import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { hasFullFeatureSet } from "@/dentlab/src/store/Central/selectors";
import { CALENDLY_DEMO_URL } from "@/lib/constants/urls";
import { FeatureGateButtons } from "./feature-gate-modal.component";
import { getFeatureGateDescription } from "./feature-gate-modal.component";

interface FeatureGateOverlayProps {
	children: React.ReactNode;
}

export const FeatureGateOverlay: React.FC<FeatureGateOverlayProps> = ({
	children,
}) => {
	const navigate = useNavigate();
	const subscriptionTier = useCentralStore((state) => state.subscriptionTier);
	const isGated = !hasFullFeatureSet(subscriptionTier);

	if (!isGated) {
		return <>{children}</>;
	}

	const handleBookDemo = () => {
		window.open(CALENDLY_DEMO_URL, "_blank");
	};

	const handleGoToSubscription = () => {
		navigate("/organisation/administration/abonnement");
	};

	return (
		<div className="relative w-full h-full">
			<div className="blur-sm pointer-events-none select-none">{children}</div>
			<div className="absolute inset-0 bg-white/50" />
			<div
				className="absolute inset-0 flex items-center justify-center"
				aria-label="feature-gate-overlay"
				data-testid="feature-gate-overlay"
			>
				<div className="bg-white rounded-lg shadow-xl border p-6 max-w-md">
					<div className="flex items-center gap-3 mb-3">
						<div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
							<Lock className="w-5 h-5 text-amber-600" />
						</div>
						<h2 className="text-xl font-semibold">Funktion nicht verfügbar</h2>
					</div>
					<p className="text-base text-gray-600 mb-6">
						{getFeatureGateDescription(subscriptionTier)}
					</p>
					<FeatureGateButtons subscriptionTier={subscriptionTier} handleBookDemo={handleBookDemo} handleGoToSubscription={handleGoToSubscription} />
				</div>
			</div>
		</div>
	);
};
